import React, { useState, useEffect, useMemo } from "react";
import axios from "axios";
import "react-datepicker/dist/react-datepicker.css";
import { useSelector, useDispatch } from "react-redux";
import { Box, Card, Container, Grid, Tooltip, Typography } from "@mui/material";
import LinkIcon from '@mui/icons-material/Link';
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
import { useNavigate } from 'react-router-dom';
import Loader from "./../../CommonLoader";
import DatagridComp from "../../DatagridComp";
import { CommonErrorAlert } from "../../../../Commonalert/commonErrorAlert";
import UserActivityTracker from "../../../../hooks/userActivityTracker";
import Commoncard from "../../Commoncard";
import ScoreGauge from "../../../../Components/chart/gaugeChart";
import Chart from "react-apexcharts";
import WarningCount from "../../Asset/esocardicon/SchemaDetail/WarningCount.svg";
import ErrorCount from "../../Asset/esocardicon/SchemaDetail/ErrorCount.svg";

export default function H1table({ datavalue, JobId, SubmitTriggered, SetSubmitTriggered, domainsection, handleModelPopUp, handleDownlodingCSV, handleDownlodingPDF, userActivityPage }) {

  const [cardData, setCardData] = useState([]);
  const [missingData, setMissingData] = useState("")
  const [loading, setLoading] = React.useState(false)
  const esodata = useSelector((state) => state);
  const ApiToken = esodata.apiauthkey.value
  const [autoheightval, SetAutoheightval] = useState(true)
  const [apiopen, setapiOpen] = React.useState(false);
  const [apierrorMsg, setapierrorMsg] = useState();
  const [tableLoading, setTableLoading] = useState(true);
  const [summaryData, setSummaryData] = useState({
    "health_score": 0,
    "total_issues": 0,
    "trend_chart": []
  });
  const navigate = useNavigate();

  const apihandleClose = () => {
    setapiOpen(false);
  };

  useEffect(() => {
    callUserdataApi(datavalue);
  }, [datavalue]);

  useEffect(() => {

    if (SubmitTriggered === true) {
      callUserdataApi(datavalue)
    }

  }, [SubmitTriggered])
  useEffect(() => {
    callUserdataApi(datavalue)

  }, [domainsection])
  const columns = [

    {
      field: "page_url",
      headerName: "Page URL",
      description: 'URL of the web page',
      minWidth: 320,
      flex: 1,
      disableClickEventBubbling: true,
      headerAlign: "center",
      align: "center",
      sortable: true,
      renderCell: (cardData) => {

        let baseUrl = cardData.row.page_url.split("/").slice(0, 3).join("/") + "/";
        let remaining = cardData.row.page_url.split("/").slice(3).join("/");

        return (
          <>
            <div className="tooltip-container">
              <div className="prefered_url_external02 tooltip-button">
                <a className="table_links" target="_blank" href={cardData.row.page_url} style={{ display: 'flex', flexDirection: 'column' }} >
                  <span className="spanlink" style={{ color: "#044792" }} >
                    <LinkIcon /> {baseUrl}
                  </span>
                  <span className="spanlink" style={{ color: "#044792", wordWrap: "break-word", wordBreak: "break-word" }}>{remaining}</span>
                </a>
              </div>
              <span className="tooltip-text">{cardData.row.page_url}</span>
            </div>
          </>
        );

      },

    },
    {
      field: "h1_text",
      headerName: "H1 Text",
      description: 'H1 text provided for the web page',
      minWidth: 300,
      flex: 1,
      disableClickEventBubbling: true,
      headerAlign: "center",
      align: "center",
      sortable: true,

    },
  ];
  const rows = cardData ?? [];
  const callUserdataApi = async (missingdatas) => {
    setLoading(true);
    setTableLoading(true);
    setCardData([])
    var dataurls = ""
    if (missingdatas == 6) {
      dataurls = `${process.env.REACT_APP_API_URL}technical/onpagecrawl/?user_domain_id=${esodata.domaindata.value.header_selected}&domain_section_id=${domainsection}&job_id=${JobId}&field_type=duplicate_h1`
    }
    else if (missingdatas == 7) {
      dataurls = `${process.env.REACT_APP_API_URL}technical/onpagecrawl/?user_domain_id=${esodata.domaindata.value.header_selected}&domain_section_id=${domainsection}&job_id=${JobId}&field_type=multiple_h1`
    }
    else if (missingdatas == 8) {
      dataurls = `${process.env.REACT_APP_API_URL}technical/onpagecrawl/?user_domain_id=${esodata.domaindata.value.header_selected}&domain_section_id=${domainsection}&job_id=${JobId}&field_type=h1_tags_available`
    }
    const datavalue = await axios
      .get(
        `${dataurls}`,
        {
          headers: {
            Authorization: `${ApiToken}`,
          },
        }
      ).catch((error) => {
        if (error?.response?.status == 599 || error?.response?.status == 500 || error?.response?.status == 400 || error?.response?.status == 404) {
          setapiOpen(true);
          setapierrorMsg(error?.response?.data?.error)
        }
        else if (error?.code == "ERR_NETWORK") {
          navigate('/errorpages')
        }
      });
    if (missingdatas == 6) {

      var dataval = datavalue?.data?.table?.duplicate_h1
    }
    else if (missingdatas == 7) {
      var dataval = datavalue?.data?.table?.multiple_h1
    }
    else if (missingdatas == 8) {
      var dataval = datavalue?.data?.table?.h1_tags_available
    }

    if (dataval) {
      const newData = dataval.map((obj, index) => {
        return { ...obj, sid: index + 1 };
      });

      setCardData(newData);
      SetAutoheightval(false)
    }
    else {
      setCardData("");
      SetAutoheightval(true)
    }
    if (datavalue?.data) {
      setSummaryData({
        "health_score": datavalue?.data?.dashboard?.health_score || 0,
        "total_issues": datavalue?.data?.dashboard?.total_issues || 0,
        "trend_chart": datavalue?.data?.dashboard?.trend_chart || []
      })
    }

    setTableLoading(false);
    setLoading(false)
    SetSubmitTriggered(false)
  };

  const cardDatas = [
    {
      value: summaryData.total_issues || 0,
      title: "Total Issues",
      iconSrc: ErrorCount,
      iconColor: 1,
      bgColor: 1,
    },

  ];

  const gaugeChart = () => {
    return (
      <div>
        {/* <span>Most Critical issue category</span> */}
        <ScoreGauge score={summaryData.health_score} width={'150px'} />
      </div>
    )
  }


  return (
    <>
      {loading === true ? <Loader /> : null}
      <div
        style={{
          width: "calc(100% - 40px)",
          marginRight: "40px",
          marginLeft: "auto",
          marginRight: "auto",
        }}
      >
        <Container maxWidth={false} className="dashboard-container">
          <Grid container spacing={2} style={{ marginBottom: '20px' }}>
            <Grid container spacing={3} xs={12} sm={12} md={5} justifyContent="center">
              {cardDatas.map((item, index) => (
                <Grid item xs={12} sm={12} md={12} key={item.id}>
                  <Commoncard
                    item={item}
                    nonclikable={true}
                  />
                </Grid>
              ))}
              <Grid item xs={12} md={12}>
                <Grid item xs={12} sm={12} md={12}>
                  <Card
                    sx={{
                      borderRadius: "16px",
                      boxShadow: "0 6px 16px rgba(0, 0, 0, 0.08)",
                      transition: "0.3s",
                      cursor: "default",
                      height: "100%",
                      // border: 1px solid #e0e0e0;
                      "&:hover": {
                        transform: "translateY(-5px)",
                        boxShadow: "0 6px 16px rgba(0, 0, 0, 0.10)",
                      },
                      overflow: "hidden",
                      border: "none"
                    }}
                  >
                    <Box
                      sx={{
                        backgroundColor: '#d1fae5',
                        p: 2.5,
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <Typography
                        variant="h4"
                        sx={{
                          fontWeight: 700,
                          fontSize: "2.5rem",
                          background: "linear-gradient(to right, #1f2937, #4b5563)",
                          WebkitBackgroundClip: "text",
                          WebkitTextFillColor: "transparent",
                          textShadow: "0 1px 1px rgba(0,0,0,0.1)",
                          letterSpacing: 1,
                        }}
                      >
                        <div style={{ justifySelf: 'center', marginTop: '1rem' }}>
                          <span style={{ fontSize: '3rem', fontWeight: 'bolder' }}>{summaryData.health_score}</span>
                          <span style={{ fontSize: '14px', marginLeft: '5px' }}>out of 100</span>
                        </div>
                      </Typography>
                      <Box
                        sx={{
                          // backgroundColor: '#7c3aed',
                          color: "#059669",
                          // p: 1.5,
                          borderRadius: "50%",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          fontSize: "1.5rem",
                        }}
                      >
                        {/* {icon} */}
                        {gaugeChart()}
                      </Box>
                    </Box>

                    <Box
                      sx={{
                        background: "#fff",
                        px: 2.5,
                        py: 3,
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        textTransform: "uppercase",
                      }}
                    >
                      <Typography
                        sx={{ fontWeight: 600, fontSize: "0.85rem", color: "#1f2937" }}
                      >
                        Health Score
                      </Typography>
                    </Box>
                  </Card>
                </Grid>
              </Grid>

            </Grid>

            <Grid item xs={12} md={7}>
              <Box className="grid_table_shodow" style={{ padding: '15px', height: '320px' }}>
                <Typography variant="subtitle1" style={{ fontWeight: 'bold', marginBottom: '10px' }}>Trend Score</Typography>
                <Chart
                  type="area"
                  height={300}
                  series={[
                    {
                      name: "Score",
                      // data: [4, 5, 6, 6, 77]
                      data: summaryData.trend_chart.map(i => i.score)
                    }
                  ]}
                  options={{
                    chart: {
                      toolbar: { show: false }
                    },
                    colors: ["#ff601f"],
                    stroke: { curve: 'smooth', width: 3 },
                    fill: {
                      type: 'gradient',
                      gradient: {
                        shadeIntensity: 1,
                        opacityFrom: 0.4,
                        opacityTo: 0.1
                      }
                    },
                    xaxis: {
                      // categories: ['Apr 12', 'Apr 13', 'Apr 14', 'Apr 15', 'Apr 16'],
                      categories: summaryData.trend_chart.map(i =>
                        new Date(i.date).toLocaleDateString('en-IN', { month: 'short', day: 'numeric' })
                      ),
                      tickPlacement: 'on', // 🔥 important
                      labels: {
                        offsetX: 50 // 👈 manual adjustment
                      }
                    },
                    yaxis: {
                      min: 0,
                      max: 80
                    },
                    grid: {
                      padding: { left: 0, right: 0 }
                    }
                  }}
                />
              </Box>
            </Grid>

          </Grid>
        </Container>

        <div className="data_table internal_source_table internal_outsource_table" style={{ width: "100%" }}>
          <DatagridComp
            columns={columns}
            rows={rows}
            autoheightval={autoheightval}
            datagridval={2}
            columnFreezeWidth={[0]}
            tableLoading={tableLoading}
            handleModelPopUp={handleModelPopUp}
            handleDownlodingCSV={handleDownlodingCSV}
            handleDownlodingPDF={handleDownlodingPDF}
            customFilter={true}
            DownloadShowFile={true}
            DownloadShowPDF={1}
            DownloadShowCSV={2}
          />


          <CommonErrorAlert
            data={{
              apiopen: apiopen,
              apiErrorMsg: apierrorMsg,
              isIconStyled: true
            }}
            closeAlert={apihandleClose} />
          <UserActivityTracker pagename={userActivityPage} />
        </div>
      </div>
    </>
  );
}
